module.exports = __webpack_public_path__ + "img/dark-green-square-table-12.d7f22fe8.png";